import { useQuery } from '@hooks/reactQuery';

import { getAlarmOran } from '@api/alarmManagement';

import { extractQueryParams } from '@utils/common';

import { IAlarmOran } from '@interfaces/alarms/alarm';

import { ALARM_LIST_ORAN } from '@constants/queryKeys';

interface IUseQueryAlarmOranReturn {
	isLoadingAlarmOran: boolean;
	alarm?: IAlarmOran;
}

export const useQueryAlarmOran = (id?: string): IUseQueryAlarmOranReturn => {
	const {
		data,
		isLoading,
	} = useQuery({
		queryKey: [ALARM_LIST_ORAN, { id }],
		queryFn: extractQueryParams(getAlarmOran),
		enabled: [!!id],
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingAlarmOran: isLoading,
		alarm: data,
	};
};
